<template>
  <div id="page-top">
    <!-- <p>Is it Idle? - {{ isIdle }}</p> -->
    <!-- <div class="alert alert-warning" role="alert" v-if="isIdle">
      Nous avons constaté une inactivité depuis <strong>15 minutes</strong>.
      Vous serez déconnecté dans <strong>{{ second }} seconde(s)</strong>.
      Veuillez bouger votre souris.
    </div> -->

    <!-- Page Wrapper -->
    <div id="wrapper">
      <SideBar />
      <!-- Content Wrapper -->
      <div id="content-wrapper" class="d-flex flex-column">
        <!-- Main Content -->
        <div id="content">
          <!-- Topbar -->
          <Header />
          <!-- End of Topbar -->

          <router-view></router-view>
        </div>
        <!-- End of Main Content -->

        <!-- Footer -->
        <Footer />
        <!-- End of Footer -->
      </div>
      <!-- End of Content Wrapper -->

      <!-- Scroll to Top Button-->
      <router-link class="scroll-to-top rounded" to="#page-top">
        <i class="fas fa-angle-up"></i>
      </router-link>

      <!-- <div id="app"></div> -->
    </div>
  </div>
</template>

<script>
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";

import SideBar from "../components/SideBar";
import Footer from "../components/Footer";
import Header from "../components/Header";
/* import JwtService from "@/helpers/jwt";
import { CURRENT_STATE } from "@/helpers/jwt"; */

import Vue from "vue";
Vue.component("VueCtkDateTimePicker", VueCtkDateTimePicker);

export default {
  name: "App",
  data() {
    return {
      // time: 300000,
    };
  },
  components: {
    SideBar,
    Footer,
    Header,
  },
/*   computed: {
    isIdle() {
      return this.$store.state.idleVue.isIdle;
    },
    second() {
      return this.time / 1000;
    },
  },
  watch: {
    isIdle: function () {
      this.sessionExpired();
    },
  }, */
  mounted() {},
  methods: {
/*     sessionExpired() {
      let timerId = setInterval(() => {
        this.time -= 1000;
        if (!this.$store.state.idleVue.isIdle) {
          clearInterval(timerId);
          this.time = 300000;
        }
        if (this.time < 1) {
          clearInterval(timerId);

          JwtService.destroy();
          window.localStorage.removeItem(CURRENT_STATE);
          this.$store.state.auth.isAuthenticated = false;
          this.$store.state.auth.logedUser = {};
          window.location.href = "/";
        }
      }, 1000);
      //alert("Vous..............");
    }, */
  },
};
</script>

<style>
/* // @import "@/assets/scss/sb-admin-2.scss"; */
@import "~vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
</style>
